import { CaretDown, GitFork, Pencil } from "@phosphor-icons/react";
import {
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuProvider,
} from "@replicate/ui";
import type { AccountWithAvatar, Model } from "../types/models";
import ForkModelDialog from "./fork-model-dialog";

export default function ModelActions({
  model,
  account,
  isOwner,
  disclosure = (
    <Button
      startIcon={<GitFork />}
      size="sm"
      variant="outlined"
      className="w-full relative"
    />
  ),
}: {
  model: Model;
  account: AccountWithAvatar;
  isOwner: boolean;
  disclosure?: React.ReactElement;
}) {
  return !isOwner ? (
    <ForkModelDialog disclosure={disclosure} model={model} account={account} />
  ) : (
    <div className="flex -space-x-px">
      <Button
        startIcon={<Pencil />}
        variant="outlined"
        className="w-full relative"
        size="sm"
        render={
          // biome-ignore lint/a11y/useAnchorContent: handled by ariakit
          <a
            className="no-underline no-default"
            href={`/editor/${model.owner}/${model.name}`}
          />
        }
      >
        <span className="whitespace-nowrap">Edit model</span>
      </Button>
      <MenuProvider placement="bottom-end">
        <MenuButton
          render={
            <IconButton
              variant="outlined"
              className="min-w-[34px] min-h-[34px]"
              size="sm"
            />
          }
        >
          <CaretDown weight="bold" />
        </MenuButton>
        <Menu className="no-focus">
          <ForkModelDialog
            model={model}
            account={account}
            disclosure={
              <MenuItem className="flex items-center gap-2">
                <GitFork />
                Fork model
              </MenuItem>
            }
          />
        </Menu>
      </MenuProvider>
    </div>
  );
}
